<div  class="header">
  <div style="text-align: right" class="pull-right">
    <mat-spinner *ngIf="loadingAction" matSuffix [diameter]="20"></mat-spinner>
    <button
      *ngIf="!loadingAction"
      matTooltip="Cancelar"
      (click)="cancel()"
      mat-icon-button
      class="card-inline"
    >
      <mat-icon>clear</mat-icon>
    </button>
    <button
      *ngIf="!loadingAction"
      matTooltip="Finalizar atención"
      (click)="finalizeMedicalAppointmentCare()"
      mat-icon-button
      class="card-inline"
    >
      <mat-icon>done</mat-icon>
    </button>
    <button
      *ngIf="!loadingAction"
      mat-icon-button
      [matMenuTriggerFor]="menuItem"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menuItem="matMenu">

      <button (click)="openMedicalAppointmentObservationDialog()" mat-menu-item>
        <mat-icon>search</mat-icon><span>Ver observaciones</span>
      </button>
      <!-- <button (click)="verMuestras()" mat-menu-item>
        <mat-icon>search</mat-icon><span>Muestras</span>
      </button> -->
      <button (click)="verPreparaciones()" mat-menu-item>
        <mat-icon>search</mat-icon><span>Prep. y Proced.</span>
      </button>
      <app-medical-appointment-reappointment-control
        (onReAppointmentChange)="onReAppointmentChange()"
        [medicalAppointmentId]="medicalAppointmentId"
      >
      </app-medical-appointment-reappointment-control>

    </mat-menu>
  </div>
</div>

<div *ngIf="!loading" class="card-base margin-botton-medium">
  <div class="card-content-scan">
    <div class="card-container">
      <div class="card-content">
        <app-received-lab-sample #receivedLab [appointmentId]="medicalAppointmentId"></app-received-lab-sample>
        <medical-order-scann-control
          [canScann]="false"
          [deliveryDate]="deliveryDate"
          [medicalorderId]="medicalOrderId"
        ></medical-order-scann-control>
      </div>
    </div>
  </div>
</div>
